import React from 'react';
import { IMAGES } from '../utils/constants';
export function WhatIsIncluded() {
  const items = [{
    image: IMAGES.tomo1,
    title: "Fondamenti dell'Educazione Fisica Moderna",
    description: 'Metodi, strategie didattiche e organizzazione delle lezioni.',
    value: '€9,99'
  }, {
    image: IMAGES.tomo2,
    title: 'Giochi di Movimento per la Scuola',
    description: 'Attività divertenti e coinvolgenti per sviluppare abilità motorie.',
    value: '€9,99'
  }, {
    image: IMAGES.tomo3,
    title: 'Percorsi Psicomotori per Insegnare',
    description: 'Percorsi e attività per coordinazione, equilibrio e orientamento.',
    value: '€9,99'
  }, {
    image: IMAGES.tomo4,
    title: 'Sport e Attività Pre-Sportive per la Scuola',
    description: 'Esercizi pratici per introdurre gli sport in modo semplice.',
    value: '€9,99'
  }, {
    image: IMAGES.tomo5,
    title: 'Pianificazione delle Lezioni e Valutazione',
    description: "Strumenti per organizzare l'insegnamento e monitorare i progressi.",
    value: '€9,99'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-331">
      <div className="max-w-6xl mx-auto" data-id="element-332">
        <div className="text-center mb-16" data-id="element-333">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-334">
            Cosa ricevi esattamente all'interno del Mega-Pack
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-335">
            5 libri completi di educazione fisica, pronti da scaricare e
            utilizzare immediatamente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-336">
          {items.map((item, index) => <div key={index} className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow flex flex-col" data-id="element-337">
              <div className="bg-blue-50 p-6 flex justify-center items-center h-64" data-id="element-338">
                <img src={item.image} alt={item.title} className="h-full object-contain drop-shadow-xl transform hover:scale-105 transition-transform" data-id="element-339" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-340">
                <div className="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full w-max mb-4" data-id="element-341">
                  LIBRO #{index + 1}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-342">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6 flex-1" data-id="element-343">
                  {item.description}
                </p>
                <div className="pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-344">
                  <span className="text-gray-500 text-sm" data-id="element-345">Valore reale:</span>
                  <span className="text-gray-900 font-bold" data-id="element-346">{item.value}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}